import { render, staticRenderFns } from "./EeiregInvlidClients.vue?vue&type=template&id=422a45ba&"
import script from "./EeiregInvlidClients.js?vue&type=script&lang=js&"
export * from "./EeiregInvlidClients.js?vue&type=script&lang=js&"
import style0 from "./EeiregInvlidClients.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports